import 'handlebars'
import skillBranchTemplate from 'templates/skills/skill_branch.hbs'

window['portal/skills#index'] = function () {
  // TOGGLE SKILL
  $(document).on('click', '.skills-tree .line[data-skill-id] .input', function (event) {
    const input = $(event.currentTarget)
    const target = $(event.target)
    const hiddenInput = input.find(`input#selected_${input.data('id')}`)
    const currentLevel = parseFloat(hiddenInput.val())
    let level
    if (target.is('input:checkbox')) {
      // BOOLEAN TYPE
      level = target.prop('checked') ? 4 : 0
      hiddenInput.val(level)
    } else {
      // STARS TYPE
      level = target.data('l')
      if (level === undefined) return
      if (currentLevel === level) {
        level = 0
        input.find('.star').removeClass('active')
      } else {
        input.find('.star').removeClass('active')
        input.find('.star:gt(' + (level * (-1) - 1) + ')').addClass('active')
      }
      hiddenInput.val(level)
    }
  })

  // COLLAPSE SKILL
  $(document).on('click', '.skills-tree .line[data-skill-id] .skill-name', function (event) {
    const skill = $(event.currentTarget).parent()
    const childrenSkills = skill.siblings('ul.children-skills')
    if (childrenSkills.length === 0) return

    if (skill.hasClass('open')) {
      childrenSkills.hide()
      skill.removeClass('open').addClass('closed')
    } else {
      childrenSkills.show()
      skill.removeClass('closed').addClass('open')
    }
  })

  // ADD NEW SKILL
  $('#add_skill_to_list').on('click', function () {
    const selectBox = $('.additional_skills #skills')
    const data = selectBox.select2('data')

    if (data) {
      selectBox.val(null).trigger('change')

      if ($('#selected_' + data.id).length) {
        const element = $('#selected_' + data.id)
        const skillName = element.parents('.line').find('.skill-name')
        skillName.css({
          background: 'yellow',
          padding: '0 5px'
        })
        setTimeout(function () {
          skillName.removeAttr('style')
        }, 5000)
        $('html, body').animate({
          scrollTop: element.closest('div').offset().top - 60
        }, 1000)
      } else {
        data.boolean = data.input_type === 'boolean'
        const node = skillBranchTemplate(data)
        $('ul.skills-tree').prepend(node)
      }
    }
  })
}
